import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent } from '@shared/controls/button/button.component';
import { AgActionIconButtonComponent } from "@shared/components/grid/ag-cells/common/ag-action-icon-button/ag-action-icon-button.component";

@Component({
  selector: 'app-common-modal-wrapper',
  standalone: true,
  imports: [
    ButtonComponent,
    FormsModule,
    ReactiveFormsModule,
    AgActionIconButtonComponent
  ],
  templateUrl: './common-modal-wrapper.component.html',
  styleUrl: './common-modal-wrapper.component.scss'
})
export class CommonModalWrapperComponent {
  @Input() isLoading = false;
  @Input() isDisabled = false;
  @Input() icon = 'ic-form-20';
  @Input() header = '';
  @Input() subheader = '';
  @Input() saveBtnText = 'Save';
  @Input() closeBtnText = 'Cancel';

  @Output() close = new EventEmitter();
  @Output() submitModal = new EventEmitter();

  onClose() {
    this.close.emit();
  }

  onSubmit() {
    this.submitModal.emit();
  }
}
